import axios from "axios"
import Vue from 'vue'

import router from '../router/index'
import Encrypt from 'encryptlong'
import VueCookies from 'vue-cookies'
import {
  Message
} from 'view-ui-plus'
const Base64 = require("js-base64").Base64;
const jsSHA = require("jssha");
import {
  aes_ecb_decrypt,
  aes_ecb_encrypt,
  get_aes_uuid
} from '@/utils/my_crypto.js'
import Fingerprint2 from 'fingerprintjs2'




const CancelToken = axios.CancelToken;
axios.defaults.withCredentials = true; // 允许跨域携带cookie


// 添加请求拦截器
axios.interceptors.request.use(config => {
  var pathname = window.location.pathname;


  return config;
}, (error) => {

  return Promise.reject(error);
});
// 添加响应拦截器s
axios.interceptors.response.use((response) => {
  console.log(response)
  if (response.data.is_encrypt) {

    var _resp_data = JSON.parse(JSON.stringify(response.data))
    let decrypt = new Encrypt();
    if (response.data.sys_status == 'staff') {
      var admin_private_key = VueCookies.get('dx_private_key')
    } else {
      var admin_private_key = VueCookies.get('admin_private_key')
    }

    decrypt.setPrivateKey(admin_private_key);
    var aes_ecb_key = decrypt.decrypt(_resp_data.key)
    // 
    var data_str = aes_ecb_decrypt(_resp_data.data, aes_ecb_key)
    var decrypt_dict = JSON.parse(data_str)
    _resp_data['data'] = decrypt_dict

    if (process.env.NODE_ENV == 'development') {
      console.log('收到响应---', decrypt_dict)
    }

    return _resp_data
  } else {
    var _resp_data = response.data;
  }

  // token过期拦截
  if (_resp_data.code == 101) {

    // 获取参数部分
    var query_str = window.location.search
    Message.warning(_resp_data.msg)
    setTimeout(() => {
      router.push({
        path: '/' + query_str,
      })
    }, 1000)



    return
  }

  return response.data;

}, function (error) {

  return error;
});



function http(type, url, data, is_encrypt, sys_status,) {

  if (process.env.NODE_ENV == 'development') {
    console.log('发起请求---', data)
  }
  // 是否加密
  if (is_encrypt) {
    console.log('需要加密')
    var encrypt = new Encrypt();

    switch (sys_status) {
      case 'staff':
        var admin_public_key = VueCookies.get('dx_public_key')
        var admin_token = VueCookies.get('dx_token')
        var admin_token_exist = VueCookies.isKey('dx_token')
        break;

      case 'visitor':
        var admin_public_key = VueCookies.get('dx_public_key')
        var admin_token = VueCookies.get('dx_token')
        var admin_token_exist = true

      default:
        var admin_public_key = VueCookies.get('admin_public_key')
        var admin_token = VueCookies.get('admin_token')
        var admin_token_exist = VueCookies.isKey('admin_token')

    }

    // if (sys_status == 'staff') {
    //   var admin_public_key = VueCookies.get('dx_public_key')
    //   var admin_token = VueCookies.get('dx_token')
    //   var admin_token_exist = VueCookies.isKey('dx_token')
    // } else {
    //   if (sys_status == 'visitor') {

    //   } else {
    //     var admin_public_key = VueCookies.get('admin_public_key')
    //     var admin_token = VueCookies.get('admin_token')
    //     var admin_token_exist = VueCookies.isKey('admin_token')
    //   }

    // }
    console.log(admin_token_exist)


    // 判断没cookies跳转到登录
    if (!admin_token_exist) {
      // admin_token = 'token---过期'
      var timer = setTimeout(function () {
        // 在这里编写需要执行的代码
        Message.warning('H1-登录超时，请重新登录')
      }, 100);
      return new Promise((resolve, reject) => {
        throw new Error('cookie过期,登录超时error')
      })


      // return 'token_error'

      // console.log('http跳回登录')
      // router.push({
      //   path: '/',
      // })
      // return new Promise((resolve, reject) => {
      //   throw new Error('cookie过期,登录超时error')
      // })
    }

    // 场景数据-浏览器指纹
    let current_browser_id = VueCookies.get('dx_browser_id')
    console.log(current_browser_id)
    if (current_browser_id == null) {
      console.log('重新获取')
      var id = Fingerprint2.get(function (components) {
        const values = components.map(function (component, index) {
          if (index === 0) { //把微信浏览器里UA的wifi或4G等网络替换成空,不然切换网络会ID不一样
            return component.value.replace(/\bNetType\/\w+\b/, '')
          }
          return component.value
        })
        // 生成最终id murmur   
        var murmur = Fingerprint2.x64hash128(values.join(''), 31)
        return murmur
      })
      var scene_data = {
        'browser_id': id
      }
      data['scene_data'] = scene_data
    } else {
      var scene_data = {
        'browser_id': current_browser_id
      }
      data['scene_data'] = scene_data
    }



    // 生成签名,加到请求体中
    var nonce = Math.random().toString(36).slice(2);
    data['nonce'] = nonce
    var timestamp = new Date().getTime()
    data['timestamp'] = timestamp

    var sign_str = admin_token + timestamp + nonce
    var sign_str_b64 = Base64.encode(sign_str);

    const shaObj = new jsSHA("SHA-256", "TEXT", {
      encoding: "UTF8"
    });
    shaObj.update(sign_str_b64);
    var sign_sha256 = shaObj.getHash("HEX");

    // Encrypt 加密
    var aes_key = get_aes_uuid()
    encrypt.setPublicKey(admin_public_key);
    var rsa_decrypt_data = encrypt.encryptLong(aes_key)
    // aes加密
    var json_data = JSON.stringify(data)
    var aes_decrypt_str = aes_ecb_encrypt(json_data, aes_key)

    var data = {
      token: admin_token,
      data: aes_decrypt_str,
      sign: sign_sha256,
      aes_key: rsa_decrypt_data
    }


  } else {
    console.log('不需要加密')
  }



  const source = CancelToken.source();
  var source_token = source.token
  let ajaxConfig = {
    method: type,
    url: url,
    data: data,
    proxy: true,
    headers: {
      'Content-Type': 'application/json'
    },
    cancelToken: source_token
  }

  return axios(ajaxConfig)
}


// 获取浏览器ID
function get_browser_id() {
  var id = Fingerprint2.get(function (components) {
    const values = components.map(function (component, index) {
      if (index === 0) { //把微信浏览器里UA的wifi或4G等网络替换成空,不然切换网络会ID不一样
        return component.value.replace(/\bNetType\/\w+\b/, '')
      }
      return component.value
    })
    // 生成最终id murmur   
    var murmur = Fingerprint2.x64hash128(values.join(''), 31)
    VueCookies.set('dx_browser_id', murmur, '7d', '/', process.env.VUE_APP_COOKIES_DOMAIN)
  })


}


function open_new_page(url, target) {
  if (!target) {
    target = '_blank'
  }
  let a = document.createElement("a");
  a.setAttribute("href", url);
  a.setAttribute("target", target);
  var id = String(new Date().getTime())
  a.setAttribute("id", id);
  // 防止反复添加      
  document.body.appendChild(a);
  a.click();

}




export {
  http,
  get_browser_id,
  open_new_page,
}